import type { PageConfig } from '../../common';
import type {
    ObjectPageHeader,
    ObjectPageLayout,
    GenericSections,
    CustomSections,
    ObjectPageFooter
} from '../controls';

export enum VariantManagementTypeObjectPage {
    None = 'None',
    Control = 'Control'
}

//Class implementations of the interfaces with sync rules at packages/specification/src/sync/v4/export/pages/ObjectPage.ts

export interface ObjectPageConfigV4 extends PageConfig {
    header?: ObjectPageHeader;
    layout?: ObjectPageLayout;
    /**
     * Determines whether variant management is enabled for tables:
     * - None (default): Variant management is disabled.
     * - Control: Variant management can be enabled individually for each control using personalization.
     */
    variantManagement?: VariantManagementTypeObjectPage;
    /**
     * Enable lazy loading for sections in an object page.
     */
    enableLazyLoading?: boolean;

    sections?: GenericSections | CustomSections;

    footer?: ObjectPageFooter;
}
